/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'info-box',
	layouts: [ {
		name: 'layout-1',
		label: 'Layout 1',
		iconAlign: 'center',
		titleAlign: 'center',
		buttonAlign: 'center',
	}, {
		name: 'layout-2',
		label: 'Layout 2',
		iconAlign: 'center',
		titleAlign: 'left',
		buttonAlign: 'left',
	}, {
		name: 'layout-3',
		label: 'Layout 3',
		iconAlign: 'center',
		titleAlign: 'right',
		buttonAlign: 'right',
	}, {
		name: 'layout-4',
		label: 'Layout 4',
		iconAlign: 'center',
		titleAlign: 'right',
		buttonAlign: 'right',
	}, {
		name: 'layout-5',
		label: 'Layout 5',
		iconAlign: 'center',
		titleAlign: 'right',
		buttonAlign: 'right',
	} ],
};
